import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {Route} from "@/routing/Router";
import {useIntl} from "react-intl";
import EmployeeHeadingActions from "@widgets/employees/editor/heading/EmployeeHeadingActions";
import {EmployeeDetails} from "@/data/entities/employee";
import {SetStateFn} from "@/utils/SetStateUtils";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";

type Props = {
    route: Route,
    initialLoading: boolean,
    employee: EmployeeDetails | null,
    setShowDeleteModal: SetStateFn<boolean>,
};

const EmployeeHeading = ({route, initialLoading, employee, setShowDeleteModal}: Props) => {
    const intl = useIntl();

    return (
        <PageHeading
            breadcrumbs={generateBreadcrumbs(route, intl)}
            title={initialLoading ? intl.formatMessage(({id: "employee"})) : route.name(intl)}
            actionRowHorizontal={false}
            actionRow={
                employee === null
                    ? undefined
                    : <EmployeeHeadingActions
                        setShowDeleteModal={setShowDeleteModal}
                    />
            }
            meta={<LocationPageMeta/>}
            breakpoints={{md: {actionRowHorizontal: true}}}
        />
    );
};

export default EmployeeHeading;